import { fetchCurrentUser } from '../../ducks/user.duck';
export const loadData = () => dispatch => dispatch(fetchCurrentUser());
